import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

const styleButBlue = { width: '100%', backgroundColor: '#28B7C3', color: "#FFFFFF", borderColor: "#319F8D" }

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function PrinciplesDialog({ data }) {
    const [open, setOpen] = React.useState(useLocation().pathname == '/principios');

    var nav = useNavigate()
    const handleClose = () => {
        window.history.pushState({}, undefined, '/');
        setOpen(false);
    };

    const handleClickOpen = () => {
        window.history.pushState({}, undefined, '/principios');
        setOpen(true);
    };

    return (
        <React.Fragment>
            <Button variant="outlined" style={styleButBlue} onClick={handleClickOpen}>
                Princípios
            </Button>
            <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            NOSSOS PRINCÍPIOS
                        </Typography>
                    </Toolbar>
                </AppBar>
                <List>
                    <ListItemButton>
                        <ListItemText primary="A Riqueza
da Diversidade"
                            secondary="A REDE se orgulha de ter nascido com grande diversida
de interna, como diverso é o Brasil e também o mundo,
como diversos são os seres humanos e os seres vivos no
planeta que compartilhamos. Diversidade é um desafio
e uma grande oportunidade. A proposta é enfrentá-lo e
a aproveitá-la desenvolvendo a cultura de cocriação, na
qual as diferenças sejam reconhecidas como fonte de riqueza criativa, dando suporte para o surgimento de res
postas integrativas, de novas e melhores soluções para
as mudanças de que o mundo necessita. Entender e respeitar a diversidade - em palavras e ações - pressupõe
reconhecer o significado da diversidade étnica, regional,
geracional, de credo e ideologia, de gênero e orientação
sexual, de contexto educacional e de formação." />

                    </ListItemButton>
                    <Divider />
                    <ListItemButton>
                        <ListItemText
                            primary="Democratizar a Democracia"
                            secondary="O caminho para a aproximação cada vez maior dessa que
hoje parece só uma utopia é o esforço para manter a coerência entre as intenções e as ações: a educação para a
democracia e para uma sociedade fraterna se inicia em
nós mesmos. A REDE reconhece as limitações da democracia representativa, que não representa e não inclui verdadeiramente toda a sociedade na vivência do espaço
público. Temos hoje os meios tecnológicos e ideológicos
para avançar rumo à radicalização da democracia. A REDE
quer gerar oportunidades para que todos os brasileiros e
brasileiras sejam parte da construção de um processo político ativo e criativo que permita implementar o real po-
tencial da democracia. Queremos criar uma comunidade
de pensamento que dê visibilidade à prática do bem comum como meta viável da sociedade e do Estado, que de-
monstre que a política pode ser uma prática socialmente
virtuosa, que torne possível integrar sonhos individuais e
coletivos, sem a pretensão de diluir as diferenças e homogeneizar os sonhos.
Democratizar
a Democracia.
O desafio é
aproximar a
po do
cotidiano, de
forma que
a participaçãO
política seja
algo natural
e intrínseco
à vida dos
cidadãos.
O desafio é aproximar a política do cotidiano, de forma
que a participação política seja algo natural e intrínseco à
vida dos cidadãos. E que o sentido da política não seja o
da luta excludente pelo poder, mas a expressão do compromisso com valores coletivos, de tal modo que seja
possível, inclusive, a colaboração entre oponentes, em
favor do interesse comum. Queremos ainda que o ideal
republicano de liberdade, fraternidade e igualdade possa
vigorar num país institucional e culturalmente democrático, com pleno respeito à sua pluralidade. Parte de nossa
contribuição para isto está em oferecer um lugar no qual
a fraternidade (solidariedade) possa ser colocada em prática, em gestos de cuidado e amorosidade.
A democracia real precisa de cidadãos responsáveis, bem
informados, bem formados e empoderados, para os quais
seja natural e necessário o engajamento político como
parte de suas vidas. Mas esses cidadãos também precisam ser nutridos em sua condição humana, e por isso
queremos um ambiente que aproxime a política de nossa
humanidade, integralmente.
O trabalho será feito, portanto, em estreita interação com
pessoas e organizações que pensam de forma semelhante, no Brasil e no mundo, desenvolvendo políticas e processos rumo à sustentabilidade local e global."
                        />
                    </ListItemButton>
                    <Divider />  
                    <ListItemButton>
                        <ListItemText
                            primary="Sustentabiliade "
                            secondary="Sustentabilidade é o coração, a visão e a missão da REDE
- é o seu próprio nome. Para entender a essencialidade
deste termo, para o alcance profundo da visão (utopia) e
a amplitude de nossa missão (prática) é preciso tomar a
expressão por inteiro, pois a sustentabilidade é integral e
sua realização vai além da junção mecânica de diferentes
aspectos.
A REDE formula 7 níveis de sustentabilidade – ambiental,
social, cultural, ética, estética, econômica e política, os
quais incluem de forma transversal as sustentabilidades
individual e coletiva e um importante componente de resiliência psicoespiritual. Assim, as 7 dimensões da sustentabilidade que a Rede abraça estão permeadas pela capa-
cidade de realização plena do indivíduo e da sociedade,
aumentando assim nossa própria capacidade de afastar
as formas de corrupção pessoal ou sistêmica."
                        />
                    </ListItemButton>
                    <Divider />
                    <ListItemButton>
                        <ListItemText
                            primary="Criando uma Cultura de Paz"
                            secondary="Estes são tempos de extrema violência. Para cada forma de sustentabilidade que se busca, pode-se identificar inúmeras formas de violência e desagregação, muitas vezes sutis, que se colocam no caminho, barrando a realização da sustentabilidade e da paz por inteiro. Cocriar uma cultura de paz começa por reconhecer a existência de formas de violência que muitos chegam a considerar como “naturais”, “normais” ou “inevitáveis”. Tais situações ocorrem corriqueiramente: pessoas que não recolhem seu lixo, não ajudam a reorganizar o local, fazem observações de cunho machista ou sexista, sobem o tom de voz como se isso reforçasse sua posição, monopolizam o tempo de fala, assumem postura de superioridade condescendente para com os mais jovens, os idosos ou os que têm dificuldades de expressão, sem realmente prestar atenção ao conteúdo de suas colocações; encantam-se com seus próprios argumentos, demonstrando impaciência e desinteresse pelas exposições alheias - somente para citar alguns exemplos. É a violência invisível do cotidiano e a cultura da competitividade desmedida e hegemônica que afasta muita gente dos espaços de mobilização e de ativismo. Esta violência repercute em todas as dimensões de nossa vida.Criando uma cultura de paz a não-violência e o pacifismo devem ser construídos - cocriados - em tantas formas quanto forem as formas de violência que se quer enfrentar. Escolher meios pacíficos de manifestação, no cotidiano e nas ruas, é sempre possível, mesmo que nem sempre fácil. Cada um tem o desejo íntimo e o potencial para a paz, a sustentabilidade e a democracia profunda. Democracia pressupõe liberdade de expressão, de organização e de manifestação. Novos atores políticos estão emergindo graças aos novos instrumentos tecnológicos que facilitam a expressão e o acesso à comunicação horizontal e não mediada ou dominada. O rompimento do monopólio da comunicação faz de cada cidadão e cidadã atores e protagonistas de sua narrativa. No entanto, esta inclusão necessita de imperativos éticos, pois a democracia só se realiza completamente dentro de uma cultura de paz."
                        />
                    </ListItemButton>
                    <Divider />
                    <ListItemButton>
                        <ListItemText
                            primary="Desenvolver nossa humanidade Individual e Coletiva"
                            secondary="Para que as pessoas se tornem seres verdadeiramente
humanos – e sustentáveis – é preciso se desenvolver individual e coletivamente, de modo integrado. O desenvol
vimento humano em seu sentido amplo precisa estar na
essência das políticas e da cultura da REDE. Pode-se pensar nesse desenvolvimento como jornada de superação
de limitações e problemas que, sem dúvida, existem. No
entanto, é importante pensar nessa jornada como oportunidade de construir a partir das capacidades existentes.
O chamado para integrar os diversos aspectos que muitas vezes colocam uma situação de muitas tensões: o horizontal e o vertical, o interno e o externo, o idealismo e o
pragmatismo, o visível e o invisível, os espaços abertos e
os restritos, os centros e as bordas. O desafio está em ir
além dos espaços e do repertório de atitudes que já são
conhecidos e dominados; está em superar alguns hábitos e encontrar outro lugar propício para “ser a mudança
que queremos ver no mundo”. É com a própria prática
que esse caminho e uma nova forma de caminhar serão
aprendidos."
                        />
                    </ListItemButton>
                    <Divider />
                    <ListItemButton>
                        <ListItemText
                            primary="Consenso Proressivo Nas Decisões Partidárias"
                            secondary="As decisões por votações, que consolidam “maioria” e
“minoria” em um grupo, estabelecem que a diversidade
de opiniões não será considerada, haverá os que sempre
ganham e decidem tudo e os que sempre perdem e são
excluídos, sem espaço para ver suas proposições sendo
contempladas. Na Rede as decisões são compreendidas
como processos construídos por escuta, argumentação,
mediação e convencimento, sem o uso de linguagem
violenta e sem desqualificação mútua. As votações são o
último recurso para encaminhar os assuntos polêmicos e
as divergências."
                        />
                    </ListItemButton>
                </List>
            </Dialog>
        </React.Fragment>
    );
}